import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: ${ ({ showSearch }) => showSearch ? '450px 1fr 350px' : '450px 1fr' };
  grid-template-rows: 1fr;
  height: 100%;
`
